<template>
  <FormPanel
    :id="'mySupport'"
    :title="'My Support'"
    class="mt-6"
    panel-content-class="text-gray-600 border-gray-200 px-4"
  >
    <template #content>
      <DetailView
        :items="detailViewItems"
        :emergency-contacts="emergencyContacts"
        @edit="editItem"
        @delete="deleteItem"
      />
      <EditView
        v-for="item in editViewItems"
        :key="item.id"
        :item-data="item"
        :emergency-contacts="emergencyContacts"
        @save="saveItem"
        @cancel="cancelEditView"
      />
      <AddButton
        v-if="detailViewItems.length + editViewItems.length < 3"
        label="Add My Support"
        @addItem="addItem"
      />
    </template>
  </FormPanel>
</template>

<script>
import FormPanel from "@/components/forms/SharedComponents/panel.vue";
import AddButton from "@/components/shared/AddButton.vue";
import DetailView from "@/components/NetworkOfSupport/Shared/DetailView.vue";
import EditView from "@/components/NetworkOfSupport/MySupport/EditView.vue";
import grid from "@/mixins/grid.js";
import formService from "@/services/form";
import { removeParenthesis } from "@/mixins/helpers.js";

export default {
  name: "MySupportForm",
  components: {
    AddButton,
    DetailView,
    EditView,
    FormPanel,
  },
  mixins: [grid],
  data() {
    return {
      formioData: {},
      formURL: "mysupport",
      submissionId: "",
    };
  },
  computed:{
    emergencyContacts() {
      return this.gridItems.filter((c) => c.emergencyContact);
    },
  },
  created() {
    this.getFormioData();
  },
  methods: {
    getFormioData() {
      formService
        .listSubmissions(this.formURL, {
          "data.application_id": this.applicationId,
          limit: 1,
        })
        .then((submissions) => {
          let items = [];
          if (submissions.length) {
            const submission = submissions[0];
            this.submissionId = submission._id ?? "";

            items = submission.data?.nosGrid ?? [];
            items.forEach((item) => {
              this.idIndex++;
              this.gridItems.push({
                id: this.idIndex,
                firstName: item.firstName ?? "",
                lastName: item.lastName ?? "",
                relationship: item.relationship ?? "",
                legalGuardian: item.legalGuardian ?? false,
                emergencyContact: item.emergencyContact ?? false,
                billingContact: item.billingContact ?? false,
                email: item.email ?? "",
                phone: item.phoneNumber ?? "",
                phoneCode: item.countryCode ?? "",
                address: item.address ?? "",
                city: item.city ?? "",
                state: item.state ?? "",
                country: item.Country ?? "",
                postalCode: item.postalCode ?? "",
                editView: false,
                submitError: "",
              });
            });
          }

          if (!items.length) this.addItem();
        });
    },
    addItem() {
      this.idIndex++;
      this.editViewItems.push({
        id: this.idIndex,
        firstName: "",
        lastName: "",
        relationship: "",
        legalGuardian: false,
        emergencyContact: false,
        billingContact: false,
        email: "",
        phone: "",
        phoneCode: "",
        address: "",
        city: "",
        state: "",
        country: "",
        postalCode: "",
        editView: true,
        submitError: "",
      });
    },
    getJsonData(items) {
      let mapItems = [];
      mapItems = items.map((item) => ({
        firstName: item.firstName ?? "",
        lastName: item.lastName ?? "",
        relationship: item.relationship ?? "",
        legalGuardian: item.legalGuardian ?? false,
        emergencyContact: item.emergencyContact ?? false,
        billingContact: item.billingContact ?? false,
        email: item.email ?? "",
        phoneNumber: item.phone ?? "",
        phone:
          item.phone && item.phoneCode
            ? removeParenthesis(
                item.phoneCode.toString() + item.phone.toString()
              )
            : "",
        countryCode: item.phoneCode ?? "",
        address: item.address ?? "",
        city: item.city ?? "",
        state: item.state ?? "",
        Country: item.country ?? "",
        postalCode: item.postalCode ?? "",
      }));
      return {
        data: {
          application_id: this.applicationId,
          nosGrid: mapItems,
        },
      };
    },
  },
};
</script>
